import React from 'react'

const SettingsFamilyIcon = (
  <>
    <path d="M12.625 6.75H8.875V11.25H12.625V6.75Z" fill="#EAC3A2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.1223 17.625C4.91668 17.625 4.75 17.4595 4.75 17.2473V12.5652C4.75 11.9424 5.1993 11.2128 5.75909 10.933L8.875 9.375C8.875 9.375 9.625 10.125 10.75 10.125C11.875 10.125 12.625 9.375 12.625 9.375L15.7409 10.933C16.2982 11.2116 16.75 11.9438 16.75 12.5652V17.2473C16.75 17.4559 16.5804 17.625 16.3777 17.625H5.1223Z"
      fill="#42A6DD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 5.625C13.75 7.28185 12.4069 8.625 10.75 8.625C9.09314 8.625 7.75 7.28185 7.75 5.625V4.5C7.75 2.84314 9.09315 1.5 10.75 1.5C12.4069 1.5 13.75 2.84314 13.75 4.5V5.625Z"
      fill="#EAD8C5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 4.87485V2.99983C13.75 2.17472 13.0782 1.49985 12.2495 1.49985H12.0625L11.6688 0.71239C11.5735 0.521928 11.3451 0.43683 11.1539 0.51328L8.79459 1.45702C8.21736 1.68791 7.75 2.37881 7.75 3.00048V4.87485C7.75 4.04642 8.42157 3.37485 9.25 3.37485H12.25C13.0784 3.37485 13.75 4.04642 13.75 4.87485Z"
      fill="#444444"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 8.25C2.5 6.17893 4.17893 4.5 6.25 4.5C8.32107 4.5 10 6.17893 10 8.25V11.2476C10 12.0773 9.32782 12.75 8.50029 12.75H3.99971C3.17144 12.75 2.5 12.0773 2.5 11.2476V8.25Z"
      fill="#87613E"
    />
    <path d="M8.125 10.5H4.375V14.7799H8.125V10.5Z" fill="#EAC3A2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.622295 17.625C0.416682 17.625 0.25 17.4575 0.25 17.2495V16.3135C0.25 15.6916 0.6993 14.9628 1.25909 14.683L4.375 13.125C4.375 13.125 5.125 13.875 6.25 13.875C7.375 13.875 8.125 13.125 8.125 13.125L11.2409 14.683C11.7982 14.9616 12.25 15.6926 12.25 16.3135V17.2495C12.25 17.4569 12.0804 17.625 11.8777 17.625H0.622295Z"
      fill="#ED69AB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 8.86295V9.4084C3.25 11.0625 4.59591 12.4084 6.25 12.4084C7.90409 12.4084 9.25 11.0625 9.25 9.4084V8.86295C9.25 8.41108 8.88369 8.04476 8.43182 8.04476C7.48193 8.04476 6.65806 7.50519 6.25 6.71582C5.84194 7.50519 5.01807 8.04476 4.06818 8.04476C3.61631 8.04476 3.25 8.41108 3.25 8.86295Z"
      fill="#EAD8C5"
    />
  </>
)

export default SettingsFamilyIcon
